import { FC, ReactElement } from 'react'

import { SvgIconProps } from '../../models'

const IconCaretRight: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg viewBox="0 0 6 11" fill="none" className={`icon-svg ${className}`}>
        <path fillRule="evenodd" clipRule="evenodd" d="M4.16625 5.5L3.53319 4.80556L0 0.986111L0.912206 0L6 5.5L0.912206 11L0 10.0139L4.16625 5.5Z" />
    </svg>
)

export default IconCaretRight
